import { render, staticRenderFns } from "./loader.html?vue&type=template&id=db635bce&scoped=true&"
import script from "./loader.js?vue&type=script&lang=js&"
export * from "./loader.js?vue&type=script&lang=js&"
import style0 from "./loader.scss?vue&type=style&index=0&id=db635bce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db635bce",
  null
  
)

export default component.exports